<template>
    <layout>
        <a-breadcrumb>
            <a-breadcrumb-item data-cy="breadcrumb-main">
                {{ $t('globals.navigation.header.admin.title') }}
            </a-breadcrumb-item>
            <a-breadcrumb-item data-cy="breadcrumb-sub">
                {{ tabTitle(this.default_tab) }}
            </a-breadcrumb-item>
        </a-breadcrumb>

        <div class="shadow-xl settings">
            <a-tabs
                default-active-key="associations"
                :active-key="default_tab"
                tab-position="left"
                size="default"
                @change="onTabChange"
                data-cy="tab-container"
            >
                <a-tab-pane key="main" :tab="tabTitle('main')" disabled />
                <a-tab-pane key="general" :tab="tabTitle('general')">
                    <tab-general :site_management="site_management" @is-form-dirty="isFormDirty" />
                </a-tab-pane>
                <a-tab-pane key="associations" :tab="tabTitle('associations')">
                    <tab-associations @is-form-dirty="isFormDirty" ref="AssociationsTab" />
                </a-tab-pane>
                <a-tab-pane key="audit-logs" :tab="tabTitle('audit-logs')">
                    <tab-audit-logs @is-form-dirty="isFormDirty" ref="AuditLogsTab" />
                </a-tab-pane>
                <a-tab-pane key="companies" :tab="tabTitle('companies')">
                    <tab-companies @is-form-dirty="isFormDirty" ref="CompaniesTab" />
                </a-tab-pane>
                <a-tab-pane key="claims" :tab="tabTitle('claims')">
                    <tab-claims ref="ClaimsTab" />
                </a-tab-pane>
                <a-tab-pane key="claimants" :tab="tabTitle('claimants')">
                    <tab-claimants ref="ClaimantsTab" />
                </a-tab-pane>
                <a-tab-pane key="deleted-claims" :tab="tabTitle('deleted-claims')">
                    <tab-deleted-claims @is-form-dirty="isFormDirty" ref="DeletedClaimsTab" />
                </a-tab-pane>
                <a-tab-pane key="covers" v-if="isCoverVaultEnabled" :tab="tabTitle('covers')">
                    <tab-covers :section_type="'site_admin'" ref="CoversTab" />
                </a-tab-pane>
                <a-tab-pane key="listmanager-meta" :tab="tabTitle('listmanager-meta')">
                    <tab-list-manager-meta
                        @is-form-dirty="isFormDirty"
                        :is_form_dirty="form_dirty"
                        ref="ListManagerMetaTab"
                    />
                </a-tab-pane>
                <a-tab-pane key="listmanager" :tab="tabTitle('listmanager')">
                    <tab-list-manager @is-form-dirty="isFormDirty" :is_form_dirty="form_dirty" ref="ListManagerTab" />
                </a-tab-pane>
                <a-tab-pane key="upload-history-claims" :tab="tabTitle('upload-history-claims')">
                    <tab-upload-history-claims @is-form-dirty="isFormDirty" ref="UploadHistoryClaimsTab" />
                </a-tab-pane>
                <a-tab-pane key="upload-history-covers" :tab="tabTitle('upload-history-covers')">
                    <tab-upload-history-covers @is-form-dirty="isFormDirty" ref="UploadHistoryCoversTab" />
                </a-tab-pane>
                <a-tab-pane key="users" :tab="tabTitle('users')">
                    <tab-users ref="UsersTab" @is-form-dirty="isFormDirty" />
                </a-tab-pane>
                <a-tab-pane key="active-sessions" :tab="tabTitle('active-sessions')">
                    <tab-active-sessions ref="ActiveSessionsTab" />
                </a-tab-pane>
                <a-tab-pane key="migrations" :tab="tabTitle('migrations')">
                    <tab-migrations @is-form-dirty="isFormDirty" ref="MigrationsTab" />
                </a-tab-pane>
                <a-tab-pane key="intermediaries" v-if="isCiaEnabled" :tab="tabTitle('intermediaries')">
                    <tab-intermediaries ref="IntermediariesTab" :section_type="'site_admin'" />
                </a-tab-pane>
            </a-tabs>
        </div>
    </layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue';
import TabGeneral from '@/components/tabs/admin/General.vue';
import TabActiveSessions from '@/components/tabs/admin/ActiveSessions.vue';
import TabAssociations from '@/components/tabs/admin/Associations.vue';
import TabAuditLogs from '@/components/tabs/admin/AuditLogs.vue';
import TabClaims from '@/components/tabs/Claims.vue';
import TabCovers from '@/components/tabs/Covers.vue';
import TabClaimants from '@/components/tabs/Claimants.vue';
import TabCompanies from '@/components/tabs/admin/Companies.vue';
import TabDeletedClaims from '@/components/tabs/admin/DeletedClaims.vue';
import TabListManagerMeta from '@/components/tabs/admin/ListManagerMeta.vue';
import TabListManager from '@/components/tabs/admin/ListManager.vue';
import TabMigrations from '@/components/tabs/admin/Migrations.vue';
import TabUploadHistoryClaims from '@/components/tabs/admin/UploadHistoryClaims.vue';
import TabUploadHistoryCovers from '@/components/tabs/admin/UploadHistoryCovers.vue';
import TabUsers from '@/components/tabs/admin/Users.vue';
import TabIntermediaries from '@/components/tabs/Intermediaries.vue';

export default {
    components: {
        Layout,
        TabGeneral,
        TabActiveSessions,
        TabAssociations,
        TabAuditLogs,
        TabCovers,
        TabClaims,
        TabClaimants,
        TabCompanies,
        TabDeletedClaims,
        TabListManagerMeta,
        TabListManager,
        TabMigrations,
        TabUploadHistoryClaims,
        TabUploadHistoryCovers,
        TabUsers,
        TabIntermediaries,
    },
    data() {
        return {
            site_management: {},
            default_tab: 'general',
            form_dirty: false,
            loaded: false,
        };
    },
    mounted() {
        this.fetch();
        this.setTab(this.$route.params.tab);
    },
    computed: {
        isCiaEnabled() {
            if (this.default_tab == 'intermediaries' || this.default_tab == 'templates') {
                if (!this.$store.state.user.modules.cia) {
                    this.onTabChange('general');
                }
            }

            return this.$store.state.user.modules.cia;
        },
        isCoverVaultEnabled() {
            if (this.default_tab == 'covers' || this.default_tab == 'templates') {
                if (!this.$store.state.user.modules.covervault) {
                    this.onTabChange('general');
                }
            }

            return this.$store.state.user.modules.covervault;
        },
    },
    beforeRouteLeave(to, from) {
        let is_edit = this.$refs.IntermediariesTab == undefined ? false : this.$refs.IntermediariesTab.is_edit;

        if (this.form_dirty || is_edit) {
            return new Promise((resolve) => {
                this.$confirm({
                    title: this.$t('admin.nav_modal.title'),
                    content: this.$t('admin.nav_modal.content'),
                    onOk() {
                        resolve(true);
                    },
                    onCancel() {
                        resolve(false);
                    },
                });
            });
        }
    },
    methods: {
        setTab(tab) {
            switch (tab) {
                case 'active-sessions':
                    if (typeof this.$refs.ActiveSessionsTab !== 'undefined') {
                        this.$refs.ActiveSessionsTab.reload();
                    }
                    this.default_tab = 'active-sessions';
                    break;
                case 'associations':
                    if (typeof this.$refs.AssociationsTab !== 'undefined') {
                        this.$refs.AssociationsTab.reload();
                    }
                    this.default_tab = 'associations';
                    break;
                case 'audit-logs':
                    if (typeof this.$refs.AuditLogsTab !== 'undefined') {
                        this.$refs.AuditLogsTab.reload();
                    }
                    this.default_tab = 'audit-logs';
                    break;
                case 'companies':
                    if (typeof this.$refs.CompaniesTab !== 'undefined') {
                        this.$refs.CompaniesTab.reload();
                    }
                    this.default_tab = 'companies';
                    break;
                case 'covers':
                    if (typeof this.$refs.CoversTab !== 'undefined') {
                        this.$refs.CoversTab.reload();
                    }
                    this.default_tab = 'covers';
                    break;
                case 'claims':
                    if (typeof this.$refs.ClaimsTab !== 'undefined') {
                        this.$refs.ClaimsTab.reload();
                    }
                    this.default_tab = 'claims';
                    break;
                case 'claimants':
                    if (typeof this.$refs.ClaimantsTab !== 'undefined') {
                        this.$refs.ClaimantsTab.reload();
                    }
                    this.default_tab = 'claimants';
                    break;
                case 'deleted-claims':
                    if (typeof this.$refs.DeletedClaimsTab !== 'undefined') {
                        this.$refs.DeletedClaimsTab.reload();
                    }
                    this.default_tab = 'deleted-claims';
                    break;
                case 'listmanager-meta':
                    if (typeof this.$refs.ListManagerMetaTab !== 'undefined') {
                        this.$refs.ListManagerMetaTab.reload();
                    }
                    this.default_tab = 'listmanager-meta';
                    break;
                case 'listmanager':
                    if (typeof this.$refs.ListManagerTab !== 'undefined') {
                        this.$refs.ListManagerTab.reload();
                    }
                    this.default_tab = 'listmanager';
                    break;
                case 'migrations':
                    if (typeof this.$refs.MigrationsTab !== 'undefined') {
                        this.$refs.MigrationsTab.reload();
                    }
                    this.default_tab = 'migrations';
                    break;
                case 'upload-history-claims':
                    if (typeof this.$refs.UploadHistoryClaimsTab !== 'undefined') {
                        this.$refs.UploadHistoryClaimsTab.reload();
                    }
                    this.default_tab = 'upload-history-claims';
                    break;
                case 'upload-history-covers':
                    if (typeof this.$refs.UploadHistoryCoversTab !== 'undefined') {
                        this.$refs.UploadHistoryCoversTab.reload();
                    }
                    this.default_tab = 'upload-history-covers';
                    break;
                case 'users':
                    if (typeof this.$refs.UsersTab !== 'undefined') {
                        this.$refs.UsersTab.reloadTable();
                    }
                    this.default_tab = 'users';
                    break;
                case 'intermediaries':
                    if (typeof this.$refs.IntermediariesTab !== 'undefined') {
                        this.$refs.IntermediariesTab.reload();
                    }
                    this.default_tab = 'intermediaries';
                    break;
                default:
                    this.default_tab = 'general';
                    break;
            }
        },
        tabTitle(key) {
            switch (key) {
                case 'main':
                    return this.$t('admin.tabs.main');
                case 'general':
                    return this.$t('admin.tabs.general');
                case 'active-sessions':
                    return this.$t('admin.tabs.active_sessions');
                case 'associations':
                    return this.$t('admin.tabs.associations');
                case 'audit-logs':
                    return this.$t('admin.tabs.audit_logs');
                case 'companies':
                    return this.$t('admin.tabs.companies');
                case 'covers':
                    return this.$t('admin.tabs.covers');
                case 'claims':
                    return this.$t('admin.tabs.claims');
                case 'claimants':
                    return this.$t('admin.tabs.claimants');
                case 'deleted-claims':
                    return this.$t('admin.tabs.deleted_claims');
                case 'listmanager-meta':
                    return this.$t('admin.tabs.listmanager_meta');
                case 'listmanager':
                    return this.$t('admin.tabs.listmanager');
                case 'migrations':
                    return this.$t('admin.tabs.migrations');
                case 'upload-history-claims':
                    return this.$t('admin.tabs.upload_history_claims');
                case 'upload-history-covers':
                    return this.$t('admin.tabs.upload_history_covers');
                case 'users':
                    return this.$t('admin.tabs.users');
                case 'intermediaries':
                    return this.$t('company.tabs.intermediaries');
            }
        },
        onTabChange(key) {
            const vm = this;
            let is_edit = this.$refs.IntermediariesTab == undefined ? false : this.$refs.IntermediariesTab.is_edit;

            if (this.form_dirty || is_edit) {
                this.$confirm({
                    title: this.$t('admin.nav_modal.title'),
                    content: this.$t('admin.nav_modal.content'),
                    onOk() {
                        vm.form_dirty = false;
                        vm.setTab(key);
                        vm.fetch();

                        if (is_edit) {
                            vm.$refs.IntermediariesTab.fetch();
                        }

                        vm.$router.push({
                            name: 'edit-admin-tab',
                            params: {
                                tab: key,
                            },
                        });
                    },
                    onCancel() {
                        vm.form_dirty = true;
                    },
                });

                this.form_dirty = vm.form_dirty;
            } else {
                this.setTab(key);
                this.fetch();

                this.$router.push({
                    name: 'edit-admin-tab',
                    params: {
                        tab: key,
                    },
                });
            }
            switch (key) {
                case 'users':
                    if (this.loaded) {
                        this.$refs.UsersTab.reloadTable();
                    } else {
                        this.loaded = true;
                    }
            }
        },
        isFormDirty(is_dirty) {
            this.form_dirty = is_dirty;
        },
        fetch() {
            this.$http
                .get('/api/management')
                .then((response) => {
                    let management_data = {
                        ...response.data.data,
                        is_enforce_filename_restriction:
                            response.data.data.is_enforce_filename_restriction == 1 ? true : false,
                        is_modules_enabled: response.data.data.is_modules_enabled == 1 ? true : false,
                    };

                    this.site_management = management_data;
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVSM01' }),
                    });
                });
        },
    },
};
</script>
